export default __webpack_public_path__ + "static/media/blue-lighten-seasonal.d79d5309.svg";